import React, { useState, useEffect } from 'react';
import {
  FlexBox,
  FlexBoxHorizontal,
  TextField,
  FlexBoxVertical,
} from '../../atoms';
import {
  SelectAllCheckBox,
  SearchButton,
} from '../../molecules';
import Menu from '../../../utils/menu';

const TestReportFilter = ({ data, onSearch }) => {
      const filterOptions = {
            ...data,
            searchValue: null,
            fabInfo: null,
          };
      const [selectedOptions, setSelectedOptions] = useState([]);

      useEffect(() => {
        // filterOptions가 업데이트된 후 sesn의 첫 번째 옵션을 자동으로 선택하고 onSearch 호출
        const newSelectedOptions = {
        mfac_compy_nm: [],
        dsgnr_goods_nm: [],
        dsgnr_mtrls_nm: [],
        fab_type: [],
        po_cntry: [],
        certi_type: [],
        gubun: [],
        sesn: filterOptions.sesn && filterOptions.sesn[0] ? filterOptions.sesn[0] : null, // 첫 번째 sesn 옵션 선택
        };
    
        setSelectedOptions(newSelectedOptions);
        // onSearch(newSelectedOptions);  // 선택된 옵션을 onSearch에 전달
      }, [data]); // data가 변경될 때마다 호출
    

      const handleSelectedOptions = (key, value) => {
            setSelectedOptions((prev) => ({
              ...prev,
              [key]: value,
            }));
          };


  return (
    <FlexBoxHorizontal style={{height: '100px', backgroundColor: '#f1f1f1b8', borderRadius: '3px', marginTop: '10px', overflow: 'auto'}}>
      <Menu 
            targetPaths={['/interstellar/X/test-report', '/interstellar/X/fabric-test-report']}
            menuItems={[
              { path: '/interstellar/X/test-report', label: 'Test Report' },
              { path: '/interstellar/X/fabric-test-report', label: 'Test Report Upload - Fabric' }
            ]}
            buttonStyle={{ left: '20px', top: '25px' }}
            position={{top: '20px', left: '-220px'}}
          />
      <FlexBoxVertical style={{height: '100px', width: '80%'}}>
        {data.sesn.length > 0 ? <>
      <FlexBoxHorizontal style={{ overflow: 'auto' }}>
            <div
            style={{
              width: '150px',
              margin: '0 7px 0 0px',
            }}
          >
            <SelectAllCheckBox
              selected={selectedOptions.sesn}
              setSelected={(value) => handleSelectedOptions('sesn', value)}
              options={filterOptions.sesn}
              title={'*시즌'}
              allSelectTitle="시즌 All"
              // isMulti
              style={{indicatorsContainer: (style) => ({
                ...style,
                backgroundColor: '#ffeb0029 !important',
                height: '36px',
              }), valueContainer: (style) => ({
                ...style,
                backgroundColor: '#ffeb0029 !important',
                height: '36px',
              })}}
            />
          </div>
          <div
            style={{
              width: '150px',
              margin: '0 7px 0 0',
            }}
          >
            <SelectAllCheckBox
              selected={selectedOptions.po_cntry}
              setSelected={(value) => handleSelectedOptions('po_cntry', value)}
              options={filterOptions.po_cntry}
              title={'발주국가'}
              allSelectTitle="발주국가 All"
              isMulti
            />
          </div>
          <div
            style={{
              width: '150px',
              margin: '0 7px 0 0',
            }}
          >
            <SelectAllCheckBox
              selected={selectedOptions.certi_type}
              setSelected={(value) => handleSelectedOptions('certi_type', value)}
              options={filterOptions.certi_type}
              title={'인증유형'}
              allSelectTitle="인증유형 All"
              isMulti
            />
          </div>
          <div
            style={{
              width: '150px',
              margin: '0 7px 0 0',
            }}
          >
            <SelectAllCheckBox
              selected={selectedOptions.gubun}
              setSelected={(value) => handleSelectedOptions('gubun', value)}
              options={filterOptions.gubun}
              title={'분류'}
              allSelectTitle="분류 All"
              isMulti
            />
          </div>
          <div
            style={{
              width: '150px',
              margin: '0 7px 0 0',
            }}
          >
            <SelectAllCheckBox
              selected={selectedOptions.fab_type}
              setSelected={(value) => handleSelectedOptions('fab_type', value)}
              options={filterOptions.fab_type}
              title={'패브릭 타입'}
              allSelectTitle="패브릭 타입 All"
              isMulti
            />
          </div>
          </FlexBoxHorizontal>
          <FlexBoxHorizontal style={{ overflow: 'auto' }}>
          <div
            style={{
              width: '150px',
              margin: '0 7px 0 0',
            }}
          >
            <SelectAllCheckBox
              selected={selectedOptions.mfac_compy_nm}
              setSelected={(value) => handleSelectedOptions('mfac_compy_nm', value)}
              options={filterOptions.mfac_compy_nm}
              title={'벤더명'}
              allSelectTitle="벤더명 All"
              isMulti
            />
          </div>
          <div
            style={{
              width: '150px',
              margin: '0 7px 0 0',
            }}
          >
            <SelectAllCheckBox
              selected={selectedOptions.dsgnr_mtrls_nm}
              setSelected={(value) => handleSelectedOptions('dsgnr_mtrls_nm', value)}
              options={filterOptions.dsgnr_mtrls_nm}
              title={'소재담당자'}
              allSelectTitle="소재담당자 All"
              isMulti
            />
          </div>
          <div
            style={{
              width: '150px',
              margin: '0 7px 0 0',
            }}
          >
            <SelectAllCheckBox
              selected={selectedOptions.dsgnr_goods_nm}
              setSelected={(value) => handleSelectedOptions('dsgnr_goods_nm', value)}
              options={filterOptions.dsgnr_goods_nm}
              title={'제품담당자'}
              allSelectTitle="제품담당자 All"
              isMulti
            />
          </div>
          <div
            style={{
              width: '150px',
              margin: '0 7px 0 0',
            }}
          >
            <TextField
              placeholder="패브릭 "
              onChange={(value) => handleSelectedOptions('fabInfo', value)}
              onKeyPress={(e) => {
                if (e.key === 'Enter') {
                  onSearch(selectedOptions);
                }
              }}
            />
          </div>
          <div
            style={{
              width: '150px',
              marginRight: '10px',
            }}
          >
            <TextField
              placeholder="발주번호/그룹번호"
              onChange={(value) => handleSelectedOptions('searchValue', value)}
              onKeyPress={(e) => {
                if (e.key === 'Enter') {
                  onSearch(selectedOptions);
                }
              }}
            />
          </div>
          
          
          </FlexBoxHorizontal></>: null}
          </FlexBoxVertical>
          <FlexBox>
          <SearchButton
            label={'검색'}
            style={{ cursor: 'pointer', marginRight: '10px' }}
            onClick={() => onSearch(selectedOptions)}
          />
          </FlexBox>
          </FlexBoxHorizontal>
  );
};

export default TestReportFilter;
